var ZevensterStateService = /** @class */ (function () {
    function ZevensterStateService() {
    }
    ZevensterStateService.prototype.getTotalPrice = function () {
        return Math.ceil(this.purchase.fields.areas.length * 40 / 9);
    };
    return ZevensterStateService;
}());
export { ZevensterStateService };
//# sourceMappingURL=zevenster-state.service.js.map